import { gql } from '@apollo/client';

import { professorActivityAnswerFragment } from '../fragments';
import { ProfessorActivityAnswer } from '../../types';

export interface DeleteActivityAnswerScoreMutationVariables {
  courseId: string;
  activityId: string;
  answerId: string;
}

export interface DeleteActivityAnswerScoreMutationResult {
  answer: ProfessorActivityAnswer;
}

export const deleteActivityAnswerScoreMutation = gql`
  mutation DeleteActivityAnswerScoreMutation($courseId: String!, $activityId: String!, $answerId: String!) {
    answer(courseId: $courseId, activityId: $activityId, answerId: $answerId)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}/score", method: "DELETE") {
      ...ProfessorActivityAnswer
    }
  }
  ${professorActivityAnswerFragment}
`;
